<?xml version="1.0" encoding="UTF-8"?>
<svg id="ICONS" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
  <path d="m10.61035,7.08496H1.38965c-.59961,0-1.08496-.48535-1.08496-1.08496s.48535-1.08496,1.08496-1.08496h9.2207c.59961,0,1.08496.48535,1.08496,1.08496s-.48535,1.08496-1.08496,1.08496Z" fill="var(--iconPrimary, #222)" stroke-width="0"/>
</svg>